<template>
  <div class="container">
    <BaseFrame :infosArr="infosArr" :able="able" :submitLoading='loading' :id="id" :idText="idText"
    :newRecord='true'  @hanldeLog='handleLog' :logData='logData' logText='操作日志' :submitText="isEdit?'':'提交'" clearText="" @submit='submit' @cancel='$router.push(-1)'>
      <div slot="content">
        <prescriptionDecoction v-if='saleData.salePrescription.retailType===3'
          ref="salePrescription" :able='able' v-model='saleData.salePrescription'
          :genderList='genderList' :pharmacistList='pharmacistList'
          :diseaseList='diseaseList'></prescriptionDecoction>
        <prescriptionCommon v-else ref="salePrescription"
          @handlePrescriptionGoods='handlePrescriptionGoods'
          :able='able'
          :type='saleData.salePrescription.retailType'
          v-model='saleData.salePrescription'
          :genderList='genderList'
          :pharmacistList='pharmacistList'
          :diseaseList='diseaseList'
          :canWrite='epSourceType'
          :isAbleUpload='isAbleUpload1'
          ></prescriptionCommon>
        <div style='padding-top:16px' v-if="isShowPurchaserInfo">
          <lk-card title="购药人信息">
            <div style='padding-top:14px'>
              <lk-form :label-width="90" >
                <lk-row :gutter='16'>
                  <lk-col :span='6'>
                    <lk-form-item label='购药人姓名:'>
                      <lk-input v-model="purchaser.purchaserName" placeholder="请输入" :disabled="!able"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col :span='6'>
                    <lk-form-item label='购药人年龄:'>
                      <lk-input v-model="purchaser.purchaserAge" placeholder="请输入" :disabled="!able"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col :span='6'>
                    <lk-form-item label='性别:'>
                      <lk-select v-model="purchaser.purchaserSex" placeholder="请选择" :disabled="!able">
                        <lk-option v-for="(item, index) in genderList" :key="index" :value='index*1'>
                          {{ item }}
                        </lk-option>
                      </lk-select>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col :span='6'>
                    <lk-form-item label='身份证号码:'>
                      <lk-input v-model="purchaser.idCard" placeholder="请输入" :disabled="!able"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col :span='6'>
                    <lk-form-item label='联系方式:'>
                      <lk-input v-model="purchaser.phone" placeholder="请输入" :disabled="!able"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col :span='6'>
                    <lk-form-item label='购买原因:'>
                      <lk-input v-model="purchaser.reason" placeholder="请输入" :disabled="!able"></lk-input>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col :span='6'>
                    <lk-form-item label='与患者关系:'>
                      <lk-select v-model="purchaser.relationship" placeholder="请选择" :disabled="!able">
                        <lk-option v-for="(item, index) in relationshipList" :key="index" :value='index*1'>
                          {{ item }}
                        </lk-option>
                      </lk-select>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-form>
            </div>
          </lk-card>
        </div>
        <div v-if="isEdit" style='padding-top:16px'>
          <lk-card >
            <div style='padding-top:14px'>

              <lk-form :label-width="90" >
                <lk-row :gutter='16'>
                  <lk-col :span='7'>

                    <lk-form-item label='修改确认:'>
                      <div style="display:flex;justify-content: space-between">
                        <lk-input v-model="confirm.account" style="width:48%" placeholder="请输入账号"></lk-input>
                        <lk-input v-model="confirm.password" class="input-password" style="width:48%" placeholder="密码"></lk-input>
                      </div>
                    </lk-form-item>
                  </lk-col>
                  <lk-col :span='17' style="display:flex;justify-content: flex-end; ">
                    <lk-button class="mr8" @click="confirm={}">重置</lk-button>
                    <lk-button type='primary'  @click="handleToken">提交修改</lk-button>
                  </lk-col>

                </lk-row>
              </lk-form>
            </div>
          </lk-card>
        </div>
      </div>
    </BaseFrame>
    <DTPModal v-model="showClear" @confirm='confirmClear' content='重置将取消当前所做更改。'></DTPModal>
    <prescriptionGoodsModal v-if="prescriptionGoods.length" v-model="prescriptionGoodsModal" :tableData='prescriptionGoods' @setSelected='setSelected'></prescriptionGoodsModal>
  </div>
</template>

<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import prescriptionCommon from '../../components/sale/Common.vue';
import prescriptionDecoction from '../../components/prescription/Decoction.vue';
import DTPModal from '../../components/DTPModal.vue';
import prescriptionGoodsModal from '../../components/prescription/PrescriptionGoodsModal.vue';
import sale from '../../services/sale';
import system from '../../services/system';
import utils from '../../libs/utils';
import storeUtils from '../../libs/storeUtil';
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'prescription',
  mixins: [queryMixins],
  components: {
    BaseFrame,
    DTPModal,
    prescriptionCommon,
    prescriptionDecoction,
    prescriptionGoodsModal,
  },
  data() {
    return {
      isAbleUpload: true,
      confirm: {},
      logData: [],
      records: [],
      isEdit: false,
      prescriptionGoods: [],
      prescriptionGoodsModal: false,
      // able:true,
      pharmacistList: [],
      isShowDaysTestMessage: false,
      diseaseList: [],
      loading: false,
      showClear: false,
      id: '',
      idText: '处方ID',
      able: true,
      infosArr: [],
      genderList: {
        1: '男',
        2: '女',
      },
      relationshipList: {
        1: '患者本人',
        2: '患者配偶',
        3: '患者子女',
        4: '患者家属',
        5: '其他',
      },
      epSourceType1: '',
      salePrescriptionId: '',
      saleData: {
        salePrescription: {
          prescriptionTime: null,
          prescriptionNo: '',
          patientPhone: '',
          patientName: '',
          prescriptionHospital: '',
          prescriptionDoctor: '',
          patientAge: null,
          diseaseId: '',
          diseaseName: '',
          patientGender: 0,
          allocater: 0,
          allocaterName: '',
          reviewer: '',
          reviewerName: '',
          additionalRemark: '',
          saleUsageList: [],
        },
      },
      saleUsageList: [],
      purchaser: {
        purchaserName: '',
        purchaserAge: '',
        purchaserSex: '',
        idCard: '',
        phone: '',
        reason: '',
        relationship: '',
      },
      diseaseInfo: [],

    };
  },
  computed: {
    diseaseName() {
      let result = '';
      this.diseaseList.forEach((item) => {
        if (item.id === this.saleData.salePrescription.diseaseId) {
          result = item.diseaseName;
        }
      });
      return result;
    },
    epSourceType() {
      return this.epSourceType1 == 9 ? true : false;//订单类型是9（药联）的话，处方信息中的患者检索，姓名，联系方式不可修改
    },
    isAbleUpload1() {
      return this.isAbleUpload || this.handlePermission('canUploadRecipeImg');
    },
    isShowPurchaserInfo() {
      return this.$store.state.storeInfo.id === storeUtils.hefei.id;
    },
  },
  methods: {
    getRecord() {
      this.$store.commit('setDisableLoading', true);

      // goods.getBaseRecord({ id: this.$route.params.id }).then((res) => {
      //   if (res.data.status === 200) {
      //     this.records = res.data.data;
      //   } else {
      //     this.$Message.error(res.data.error);
      //   }
      // }).catch((err) => {
      //   utils.handleError(err);
      // });
    },
    setSelected(list) {
      console.log(list);

      const res = list.map((item) => {
        item.spec = item.specifications;
        return item;
      });
      this.$refs.salePrescription.setSaleUsageList(res);
    },
    handlePrescriptionGoods(val) {
      this.prescriptionGoodsModal = val;
    },
    getpharmacistList() {
      return new Promise((resolve) => {
        system.storeUserList({
          page: 1,
          size: 1000,
          // roleId: 3,
          majorType: 1,
          statusCodeList: [1],

        }).then((res) => {
          if (res.data.status === 200) {
            // this.diseaseList = res.data.data;
            const list = [];
            res.data.data.list.forEach((item) => {
              list.push(item.sysUser); // 抽取sysUser
            });
            this.pharmacistList = list;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },


    handleDaysTestMessage() {
      if (this.isShowDaysTestMessage) {
        return;
      }
      this.isShowDaysTestMessage = true;
      this.$Message.error({
        content: '用药提醒天数应小于用药周期的正整数',
        onClose: () => {
          this.isShowDaysTestMessage = false;
          console.log('close');
        },
      });
    },
    setAble(val) { // frame判定框架是否支持录入
      this.able = val;
      if (!this.able) {
        this.$set(this.ruleValidate, null);
        this.ruleValidate = null;
      }
    },
    getRecipeInfo(prescriptionId) {
      sale.getRecipeInfo({
        prescriptionId, encrypt: !this.able,
      }).then((res) => {
        if (res.data.status === 200) {
          const {
            data,
          } = res.data;
          this.id = data.salePrescription.id.toString();
          if (data.purchaser) {
            Object.assign(this.purchaser, data.purchaser);
          }
          const infosArr = [{
            name: '销售订单号:',
            value: data.salePrescription.orderNo,
          }, {
            name: '药师:',
            value: data.salePrescription.createUserName,
          }, {
            name: '创建时间:',
            value: utils.exchangeTimeToSecond(data.salePrescription.createTime),
          }, {
            name: '订单来源:',
            value: data.saleOrder.epSourceTypeName,
          }];
          // 是否满足处方照片更换条件(1、符合。2、不符合。3、没有图片，点击上传)
          this.isAbleUpload = data.picRepConditions != 2;
          infosArr.forEach((item) => {
            this.infosArr.push(item);
          });
          this.saleData.salePrescription = data.salePrescription;

          const { provinceId, cityId, countyId } = data.salePrescription;
          this.saleData.salePrescription.locationArr = [
            provinceId, cityId, countyId,
          ];
          const { provinceName, cityName, countyName } = data.salePrescription;
          this.saleData.salePrescription.locationString = countyName ? `${provinceName}/${cityName}/${countyName}` : '';

          this.epSourceType1 = data.saleOrder.epSourceType || '';
          this.saleData.salePrescription.saleUsageList = data.saleUsageVoList.map((item) => {
            const result = Object.assign(item.saleUsage, item.goodsInfoVo);
            return result;
          });
          this.prescriptionGoods = data.saleGoodsDetailList.map((item) => {
            const result = utils.deepClone(item.saleOrderDetail);
            result.isPatientRebuy = item.goodsInfoVo.isPatientRebuy;
            result._disabled = result.isRX === 1;
            this.saleData.salePrescription.saleUsageList.forEach((subItem) => {
              if (subItem.goodsStoreId === result.goodsStoreId) {
                result._checked = true;
              }
            });

            return result;
          });
          // this.saleUsageList = data.saleUsageList;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    confirmClear() {
      this.saleData = {
        salePrescription: {
          prescriptionNo: '',
          patientPhone: '',
          patientName: '',
          prescriptionHospital: '',
          prescriptionDoctor: '',
          patientAge: '',
          diseaseId: '',
          diseaseName: '',
          patientGender: 1,
          allocater: 0,
          allocaterName: '',
          reviewer: '',
          reviewerName: '',
          additionalRemark: '',
        },
        saleUsageList: [],
      };
      Object.assign(this.purchaser, {
        purchaserName: '',
        purchaserAge: '',
        purchaserSex: '',
        idCard: '',
        phone: '',
        reason: '',
        relationship: '',
      });
      // if (this.$route.name !== 'recipsSalesAdd') {
      // this.getModifiedRecord(this.$route.params.id);
      // this.getInfos(this.$route.params.id).then(() => {
      //   this.getRoleInfos();
      // });
      // } else {

      // }
      this.showClear = false;
    },
    getDiseaseInfo() {
      sale.getDiseaseInfo().then((res) => {
        if (res.data.status === 200) {
          this.diseaseInfo = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleParams() {
      let saleUsageListTest = false;
      this.saleData.salePrescription.saleUsageList && this.saleData.salePrescription
        .saleUsageList.forEach((item) => {
          if (item.rebuyRemindDays > item.medicationCycle) {
            this.handleDaysTestMessage();

            saleUsageListTest = true;
          }
        });
      if (saleUsageListTest) {
        return false;
      }
      if (this.saleData.salePrescription.picUrls) {
        this.saleData.salePrescription.picUrl = this.saleData.salePrescription.picUrls[0];
      }
      const temp = utils.deepClone(this.saleData);
      temp.saleUsageList = utils.deepClone(this.saleData.salePrescription.saleUsageList);
      temp.salePrescription.diseaseId = utils.isMatchFilter(this.diseaseList, temp
        .salePrescription.diseaseId);
      this.pharmacistList.forEach((item) => {
        temp.salePrescription.reviewer === item.id ? temp.salePrescription
          .reviewerName = item.name : '';
        temp.salePrescription.allocater === item.id ? temp.salePrescription
          .allocaterName = item.name : '';
      });
      if (this.isShowPurchaserInfo) {
        temp.purchaser = utils.deepClone(this.purchaser);
      }
      return temp;
    },
    submit() { // 验证函数
      // this.saleData.saleUsageInfoList = this.saleUsageList;
      this.$refs.salePrescription.validate().then((valid) => {
        const temp = this.handleParams();
        if (valid && temp) {
          sale.updatePrescription(temp).then((res) => {
            // console.log(this.saleData);
            if (res.data.status === 200) {
              this.$Message.success('保存成功');

              this.$router.push({
                name: 'recipeSalesRecord',
              });
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    getDiseaseList() {
      return new Promise((resolve) => {
        sale.getDiseaseInfo().then((res) => {
          if (res.data.status === 200) {
            this.diseaseList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    handleEdit(token) {
      const temp = this.handleParams();
      console.log(temp);
      if (temp) {
        temp.prescription_finish_token = token;
        sale.editPrescription(temp).then((res) => {
          if (res.data.status === 200) {
            this.$Message.success('修改成功');

            this.$router.push({
              name: 'recipeSalesRecord',
            });
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    },
    handleToken() {
      this.$refs.salePrescription.validate().then((valid) => {
        if (valid) {
          if (!this.confirm.account || !this.confirm.password) {
            this.$Message.error('请输入用户名和密码');
            return;
          }

          system.PrescriptionFinishToken(this.confirm).then((res) => {
            if (res.data.status === 200) {
              this.handleEdit(res.data.data);
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    handleLog() {
      this.logData = [];
      sale.getEditLog({
        bizType: 1,
        bizId: this.id,
      }).then((res) => {
        if (res.data.status === 200) {
          this.logData = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    Promise.all([
      this.getDiseaseList(),
      this.getpharmacistList(),
    ])
      .then(() => {
        // console.log(`-------${this.$route.params.id}`);
        this.getRecipeInfo(this.$route.params.id);
      });
    if (this.$route.name === 'viewRecipsSales') {
      this.able = false;
      this.isAbleUpload = false;
    } else if (this.$route.name === 'recipeSalesEdit') {
      this.isEdit = true;
      this.getRecord();
    }
    // this.getDiseaseInfo();
  },
};

</script>

<style scoped lang='less'>
  .breakagetables table {
    width: 100%;
    border-collapse: collapse;
  }

  .breakagetables table tr {
    height: 46px;

  }

  .breakagetables table td,
  .breakagetables table th {
    border: 1px solid #dedede;
    min-width: 10%;
    padding: 0 13px;
  }

  .breakagetables table thead {
    background: #fafafa;
    font-weight: 500
  }

  .goodsTable {

    // overflow: auto;
    // overflow-x: auto;
    // border: 1px solid #eee;
    table {
      width: 100%;
      border-collapse: collapse;
      border: 1px solid #eee;

      tr {
        height: 46px
      }

      td {
        border: 1px solid #dedede;
        min-width: 110px;
        padding: 0 13px;

      }

      thead {
        background: #fafafa;
        font-weight: 500
      }
    }

    .detail {
      background: #F5F5F5;
      padding: 12px 24px;

      >td {
        padding-right: 0;

        >div {

          display: flex;
          flex-wrap: wrap
        }
      }

      .detailItem {
        margin-right: 30px
      }
    }
  }

  /*.detail{*/
  /*background: #F5F5F5;*/
  /*padding: 12px 24px;*/
  /*>td{*/
  /*padding-right: 0*/
  /*}*/
  /*.detailItem{*/
  /*margin-right: 30px*/
  /*}*/
  /*}*/
  /*}*/

</style>
